<nz-page-header nzTitle="Dynamic Entity" [nzSubtitle]="dynamicEntity?.label"></nz-page-header>
<ng-container *ngIf="dynamicEntity">


	<nz-form-item>
		<nz-form-label [nzSpan]="2" nzFor="template" [nzLabelAlign]="'left'">Template</nz-form-label>
		<nz-form-control [nzSpan]="7">
			<nz-select id="template" [(ngModel)]="dynamicEntity!.template" (ngModelChange)="templateChanged()" [compareWith]="compareTemplates">
				<ng-container *ngFor="let template of templates">
					<nz-option [nzValue]="template" [nzLabel]="template.name"></nz-option>
				</ng-container>
			</nz-select>
		</nz-form-control>
	</nz-form-item>
	<div class="row">
		<div class="col d-flex justify-content-start">
			<button *ngIf="showAddField" nz-button nzType="dashed" class="mb-1 me-1" (click)="addFieldProperty()">+ Add Field</button>
			<button nz-button nzType="dashed" class="mb-1" (click)="addDynamicProperty()">+ Add Dynamic Property</button>
		</div>
		<div class="col d-flex justify-content-end">
			<button nz-button nzType="primary" class="mb-1" (click)="doSave()">Save</button>
		</div>
	</div>

	<nz-table nzSize="small" [nzData]="wrappers" [nzFrontPagination]="false" class="table-secondary-zorro">
		<thead>
			<tr>
				<th></th>
				<th>Name</th>
				<th>Description</th>
				<th>DataType</th>
				<th>Index</th>
				<th>Validation</th>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let item of wrappers">
				<tr (dblclick)="viewProperty(item)">
					<td *ngIf="item.dependents.length == 0">
						<fa-icon *ngIf="item.validSection == false" [icon]="faWarning" class="text-danger" nz-tooltip="Invalid template placement"></fa-icon>
						<span class="float-end">
							<nz-tag *ngIf="item.payload.type == 'Field'" [nzColor]="'orange'">F</nz-tag>
							<nz-tag *ngIf="item.payload.type == 'Dynamic'" [nzColor]="'blue'">D</nz-tag>
						</span>
					</td>
					<td *ngIf="item.dependents.length > 0" [(nzExpand)]="item.expand">
						<fa-icon *ngIf="item.validSection == false" [icon]="faWarning" class="text-danger" nz-tooltip="Invalid template placement"></fa-icon>
						<span class="float-end">
							<nz-tag *ngIf="item.payload.type == 'Field'" [nzColor]="'orange'">F</nz-tag>
							<nz-tag *ngIf="item.payload.type == 'Dynamic'" [nzColor]="'blue'">D</nz-tag>
						</span>
					</td>
					<td>{{item.payload.name}}</td>
					<td>{{item.payload.description}}</td>
					<td>{{item.payload.dataType}}</td>
					<td>{{item.payload.orderIndex}}</td>
					<td>
						<nz-tag [nzColor]="item.payload.required == true ? 'blue' : '#ddd'">
							<fa-icon [icon]="faAsterisk"></fa-icon>
						</nz-tag>
						<nz-tag [nzColor]="item.payload.isUnique == true ? 'blue' : '#ddd'">
							<fa-icon [icon]="faKey"></fa-icon>
						</nz-tag>
						<nz-tag [nzColor]="item.payload.regex ? 'blue' : '#ddd'">
							<fa-icon [icon]="faCode"></fa-icon>
						</nz-tag>
						<nz-tag [nzColor]="item.payload.minValue ? 'blue' : '#ddd'">
							<fa-icon [icon]="faArrowDown"></fa-icon>
						</nz-tag>
						<nz-tag [nzColor]="item.payload.maxValue ? 'blue' : '#ddd'">
							<fa-icon [icon]="faArrowUp"></fa-icon>
						</nz-tag>
					</td>
				</tr>
				<tr *ngIf="item.dependents.length > 0" [nzExpand]="item.expand">
					<ng-container *ngTemplateOutlet="nestedTable; context: { data: item }"></ng-container>
				</tr>
			</ng-container>
		</tbody>
	</nz-table>

	<ng-template #nestedTable let-data="data">
		<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
			<thead>
				<tr>
					<th></th>
					<th>Dependent Value</th>
					<th>Name</th>
					<th>Description</th>
					<th>DataType</th>
					<th>Index</th>
					<th>Validation</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let item of data.dependents">
					<tr (dblclick)="viewProperty(item)">
						<td *ngIf="item.dependents.length == 0">
							<fa-icon *ngIf="item.validSection == false" [icon]="faWarning" class="text-danger" nz-tooltip="Invalid template placement"></fa-icon>
							<span class="float-end">
								<nz-tag *ngIf="item.payload.type == 'Field'" [nzColor]="'orange'">F</nz-tag>
								<nz-tag *ngIf="item.payload.type == 'Dynamic'" [nzColor]="'blue'">D</nz-tag>
							</span>
						</td>
						<td *ngIf="item.dependents.length > 0" [(nzExpand)]="item.expand">
							<fa-icon *ngIf="item.validSection == false" [icon]="faWarning" class="text-danger" nz-tooltip="Invalid template placement"></fa-icon>
							<span class="float-end">
								<nz-tag *ngIf="item.payload.type == 'Field'" [nzColor]="'orange'">F</nz-tag>
								<nz-tag *ngIf="item.payload.type == 'Dynamic'" [nzColor]="'blue'">D</nz-tag>
							</span>
						</td>
						<td>
							<fa-icon *ngIf="item.payload.dependencyValueInverted" [icon]="faReverse"></fa-icon>
							{{item.payload.dependencyValue}}
						</td>
						<td>{{item.payload.name}}</td>
						<td>{{item.payload.description}}</td>
						<td>{{item.payload.dataType}}</td>
						<td>{{item.payload.orderIndex}}</td>
						<td>
							<nz-tag [nzColor]="item.payload.required == true ? 'blue' : '#ddd'">
								<fa-icon [icon]="faAsterisk"></fa-icon>
							</nz-tag>
							<nz-tag [nzColor]="item.payload.isUnique == true ? 'blue' : '#ddd'">
								<fa-icon [icon]="faKey"></fa-icon>
							</nz-tag>
							<nz-tag [nzColor]="item.payload.regex ? 'blue' : '#ddd'">
								<fa-icon [icon]="faCode"></fa-icon>
							</nz-tag>
							<nz-tag [nzColor]="item.payload.minValue ? 'blue' : '#ddd'">
								<fa-icon [icon]="faArrowDown"></fa-icon>
							</nz-tag>
							<nz-tag [nzColor]="item.payload.maxValue ? 'blue' : '#ddd'">
								<fa-icon [icon]="faArrowUp"></fa-icon>
							</nz-tag>
						</td>
					</tr>
					<tr *ngIf="item.dependents.length > 0" [nzExpand]="item.expand">
						<ng-container *ngTemplateOutlet="nestedTable; context: { data: item }"></ng-container>
					</tr>
				</ng-container>
			</tbody>
		</nz-table>
	</ng-template>
</ng-container>
